import { render } from "./LesTuteursPage.vue?vue&type=template&id=99a539e6"
import script from "./LesTuteursPage.vue?vue&type=script&lang=js"
export * from "./LesTuteursPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__